import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CommsService } from '../../services/comms/comms.service';
import { DisplayService } from '../../services/display/display.service';
import { NoteService } from '../../services/note/note.service';
@Component({
	selector: 'pcm-login-help',
	templateUrl: './login-help.component.html',
	styleUrls: ['./login-help.component.scss']
})

export class LoginHelpComponent implements OnInit {
	isContractorsOpen = false;
	isManagersOpen = false;
	isOtherOpen = false;

	contractorsText = [];
	managersText = [];
	otherUsersText = [];
	loginHelp: any;

	constructor(
		private commsService: CommsService,
		private displayService: DisplayService,
		public noteService: NoteService
	) {}

	ngOnInit() {
		this.loadLoginHelp();
		this.noteService.currentNote.active = false;
	}

	loadLoginHelp() {
		this.displayService.startLoading();
		this.commsService.getLoginHelp().subscribe(response => {
			const successData = this.commsService.getSuccessData(response);
			if (successData) {
				this.loginHelp = successData;
				this.contractorsText = this.loginHelp.contractors;
				this.managersText = this.loginHelp.managers;
				this.otherUsersText = this.loginHelp.others;
			}
			this.displayService.endLoading();
		}, err => {
			this.commsService.handleAPIError('Load login help ', err);
			this.displayService.endLoading();
		});
	}

	onCloseNote() {
		this.noteService.currentNote.active = false;
	}
}
